/* Project Import will be here */
import { post, IRequest } from "./index";
/* Project Import will be here */

export const getNotificationCountApi = () => {
    const request: IRequest = {
        subUrl: `/Notification/NotificationCount`
    };
    return post(request);
};

export const getNotificationDetailsApi = () => {
    const request: IRequest = {
        subUrl: `/Notification/NotificationDetail`
    };
    return post(request);
};

export const updateNotificationStatusApi = (data: any) => {
    const request: IRequest = {
        subUrl: `/Notification/NotificationStatus`,
        data: data
    };
    return post(request);
};